import React from 'react';
import LessonHome from '../LessonHome';

const Lesson16 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson16;